'use client';
"use strict";

var _excluded = ["children"],
  _excluded2 = ["children", "index", "orientation", "showLastSeparator"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Step: function Step() {
    return _Step;
  },
  StepDescription: function StepDescription() {
    return _StepDescription;
  },
  StepIcon: function StepIcon() {
    return _StepIcon;
  },
  StepIndicator: function StepIndicator() {
    return _StepIndicator;
  },
  StepIndicatorContent: function StepIndicatorContent() {
    return _StepIndicatorContent;
  },
  StepNumber: function StepNumber() {
    return _StepNumber;
  },
  StepSeparator: function StepSeparator() {
    return _StepSeparator;
  },
  StepStatus: function StepStatus() {
    return _StepStatus;
  },
  StepTitle: function StepTitle() {
    return _StepTitle;
  },
  Stepper: function Stepper() {
    return _Stepper;
  },
  useStepContext: function useStepContext() {
    return _useStepContext;
  },
  useStepperStyles: function useStepperStyles() {
    return _useStepperStyles;
  },
  useSteps: function useSteps() {
    return _useSteps;
  }
});
module.exports = __toCommonJS(src_exports);

// src/step.tsx
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_system2 = require("@chakra-ui/system");

// src/step-context.tsx
var import_react_context = require("@chakra-ui/react-context");
var import_system = require("@chakra-ui/system");
var _ref = (0, import_react_context.createContext)({
    name: "StepContext"
  }),
  _ref2 = _slicedToArray(_ref, 2),
  StepContextProvider = _ref2[0],
  _useStepContext = _ref2[1];
var _ref3 = (0, import_system.createStylesContext)("Stepper"),
  _ref4 = _slicedToArray(_ref3, 2),
  StepperStylesProvider = _ref4[0],
  _useStepperStyles = _ref4[1];

// src/step.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var _Step = (0, import_system2.forwardRef)(function Step2(props, ref) {
  var _useStepContext2 = _useStepContext(),
    orientation = _useStepContext2.orientation,
    status = _useStepContext2.status,
    showLastSeparator = _useStepContext2.showLastSeparator;
  var styles = _useStepperStyles();
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    "data-status": status,
    "data-orientation": orientation,
    "data-stretch": (0, import_shared_utils.dataAttr)(showLastSeparator),
    __css: styles.step
  }, props), {}, {
    className: (0, import_shared_utils.cx)("chakra-step", props.className)
  }));
});

// src/step-description.tsx
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_system3 = require("@chakra-ui/system");
var import_jsx_runtime2 = require("react/jsx-runtime");
var _StepDescription = (0, import_system3.forwardRef)(function StepDescription2(props, ref) {
  var _useStepContext3 = _useStepContext(),
    status = _useStepContext3.status;
  var styles = _useStepperStyles();
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system3.chakra.p, _objectSpread(_objectSpread({
    ref: ref,
    "data-status": status
  }, props), {}, {
    className: (0, import_shared_utils2.cx)("chakra-step__description", props.className),
    __css: styles.description
  }));
});

// src/step-icon.tsx
var import_icon = require("@chakra-ui/icon");
var import_shared_utils3 = require("@chakra-ui/shared-utils");

// src/icons.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
function CheckIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)("svg", _objectSpread(_objectSpread({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    height: "1em",
    width: "1em"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime3.jsx)("path", {
      fillRule: "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      clipRule: "evenodd"
    })
  }));
}

// src/step-icon.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
function _StepIcon(props) {
  var _useStepContext4 = _useStepContext(),
    status = _useStepContext4.status;
  var styles = _useStepperStyles();
  var icon = status === "complete" ? CheckIcon : void 0;
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    as: icon,
    __css: styles.icon
  }, props), {}, {
    className: (0, import_shared_utils3.cx)("chakra-step__icon", props.className)
  }));
}

// src/step-indicator.tsx
var import_shared_utils6 = require("@chakra-ui/shared-utils");
var import_system5 = require("@chakra-ui/system");

// src/step-number.tsx
var import_shared_utils4 = require("@chakra-ui/shared-utils");
var import_system4 = require("@chakra-ui/system");
var import_jsx_runtime5 = require("react/jsx-runtime");
var _StepNumber = (0, import_system4.forwardRef)(function StepNumber2(props, ref) {
  var children = props.children,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useStepContext5 = _useStepContext(),
    status = _useStepContext5.status,
    index = _useStepContext5.index;
  var styles = _useStepperStyles();
  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system4.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    "data-status": status,
    __css: styles.number
  }, restProps), {}, {
    className: (0, import_shared_utils4.cx)("chakra-step__number", props.className),
    children: children || index + 1
  }));
});

// src/step-status.tsx
var import_shared_utils5 = require("@chakra-ui/shared-utils");
var import_jsx_runtime6 = require("react/jsx-runtime");
function _StepStatus(props) {
  var complete = props.complete,
    incomplete = props.incomplete,
    active = props.active;
  var context = _useStepContext();
  var render = null;
  switch (context.status) {
    case "complete":
      render = (0, import_shared_utils5.runIfFn)(complete, context);
      break;
    case "incomplete":
      render = (0, import_shared_utils5.runIfFn)(incomplete, context);
      break;
    case "active":
      render = (0, import_shared_utils5.runIfFn)(active, context);
      break;
  }
  return render ? /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_jsx_runtime6.Fragment, {
    children: render
  }) : null;
}

// src/step-indicator.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
function _StepIndicator(props) {
  var _useStepContext6 = _useStepContext(),
    status = _useStepContext6.status;
  var styles = _useStepperStyles();
  return /* @__PURE__ */(0, import_jsx_runtime7.jsx)(import_system5.chakra.div, _objectSpread(_objectSpread({
    "data-status": status
  }, props), {}, {
    __css: styles.indicator,
    className: (0, import_shared_utils6.cx)("chakra-step__indicator", props.className)
  }));
}
function _StepIndicatorContent() {
  return /* @__PURE__ */(0, import_jsx_runtime7.jsx)(_StepStatus, {
    complete: /* @__PURE__ */(0, import_jsx_runtime7.jsx)(_StepIcon, {}),
    incomplete: /* @__PURE__ */(0, import_jsx_runtime7.jsx)(_StepNumber, {}),
    active: /* @__PURE__ */(0, import_jsx_runtime7.jsx)(_StepNumber, {})
  });
}

// src/step-separator.tsx
var import_shared_utils7 = require("@chakra-ui/shared-utils");
var import_system6 = require("@chakra-ui/system");
var import_jsx_runtime8 = require("react/jsx-runtime");
var _StepSeparator = (0, import_system6.forwardRef)(function StepSeparator2(props, ref) {
  var _useStepContext7 = _useStepContext(),
    orientation = _useStepContext7.orientation,
    status = _useStepContext7.status,
    isLast = _useStepContext7.isLast,
    showLastSeparator = _useStepContext7.showLastSeparator;
  var styles = _useStepperStyles();
  if (isLast && !showLastSeparator) return null;
  return /* @__PURE__ */(0, import_jsx_runtime8.jsx)(import_system6.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    role: "separator",
    "data-orientation": orientation,
    "data-status": status,
    __css: styles.separator
  }, props), {}, {
    className: (0, import_shared_utils7.cx)("chakra-step__separator", props.className)
  }));
});

// src/step-title.tsx
var import_shared_utils8 = require("@chakra-ui/shared-utils");
var import_system7 = require("@chakra-ui/system");
var import_jsx_runtime9 = require("react/jsx-runtime");
var _StepTitle = (0, import_system7.forwardRef)(function StepTitle2(props, ref) {
  var _useStepContext8 = _useStepContext(),
    status = _useStepContext8.status;
  var styles = _useStepperStyles();
  return /* @__PURE__ */(0, import_jsx_runtime9.jsx)(import_system7.chakra.h3, _objectSpread(_objectSpread({
    ref: ref,
    "data-status": status
  }, props), {}, {
    __css: styles.title,
    className: (0, import_shared_utils8.cx)("chakra-step__title", props.className)
  }));
});

// src/stepper.tsx
var import_shared_utils9 = require("@chakra-ui/shared-utils");
var import_system8 = require("@chakra-ui/system");
var import_react = require("react");
var import_jsx_runtime10 = require("react/jsx-runtime");
var _Stepper = (0, import_system8.forwardRef)(function Stepper2(props, ref) {
  var styles = (0, import_system8.useMultiStyleConfig)("Stepper", props);
  var _ref5 = (0, import_system8.omitThemingProps)(props),
    children = _ref5.children,
    index = _ref5.index,
    _ref5$orientation = _ref5.orientation,
    orientation = _ref5$orientation === void 0 ? "horizontal" : _ref5$orientation,
    _ref5$showLastSeparat = _ref5.showLastSeparator,
    showLastSeparator = _ref5$showLastSeparat === void 0 ? false : _ref5$showLastSeparat,
    restProps = _objectWithoutProperties(_ref5, _excluded2);
  var stepElements = import_react.Children.toArray(children);
  var stepCount = stepElements.length;
  function getStatus(step) {
    if (step < index) return "complete";
    if (step > index) return "incomplete";
    return "active";
  }
  return /* @__PURE__ */(0, import_jsx_runtime10.jsx)(import_system8.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    "aria-label": "Progress",
    "data-orientation": orientation
  }, restProps), {}, {
    __css: styles.stepper,
    className: (0, import_shared_utils9.cx)("chakra-stepper", props.className),
    children: /* @__PURE__ */(0, import_jsx_runtime10.jsx)(StepperStylesProvider, {
      value: styles,
      children: stepElements.map(function (child, index2) {
        return /* @__PURE__ */(0, import_jsx_runtime10.jsx)(StepContextProvider, {
          value: {
            index: index2,
            status: getStatus(index2),
            orientation: orientation,
            showLastSeparator: showLastSeparator,
            count: stepCount,
            isFirst: index2 === 0,
            isLast: index2 === stepCount - 1
          },
          children: child
        }, index2);
      })
    })
  }));
});

// src/use-steps.ts
var import_react2 = require("react");
function _useSteps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$index = props.index,
    index = _props$index === void 0 ? 0 : _props$index,
    count = props.count;
  var _ref6 = (0, import_react2.useState)(index),
    _ref7 = _slicedToArray(_ref6, 2),
    activeStep = _ref7[0],
    setActiveStep = _ref7[1];
  var maxStep = typeof count === "number" ? count - 1 : 0;
  var activeStepPercent = activeStep / maxStep;
  return {
    activeStep: activeStep,
    setActiveStep: setActiveStep,
    activeStepPercent: activeStepPercent,
    isActiveStep: function isActiveStep(step) {
      return step === activeStep;
    },
    isCompleteStep: function isCompleteStep(step) {
      return step < activeStep;
    },
    isIncompleteStep: function isIncompleteStep(step) {
      return step > activeStep;
    },
    getStatus: function getStatus(step) {
      if (step < activeStep) return "complete";
      if (step > activeStep) return "incomplete";
      return "active";
    },
    goToNext: function goToNext() {
      setActiveStep(function (step) {
        return typeof count === "number" ? Math.min(count, step + 1) : step + 1;
      });
    },
    goToPrevious: function goToPrevious() {
      setActiveStep(function (step) {
        return Math.max(0, step - 1);
      });
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Step: _Step,
  StepDescription: _StepDescription,
  StepIcon: _StepIcon,
  StepIndicator: _StepIndicator,
  StepIndicatorContent: _StepIndicatorContent,
  StepNumber: _StepNumber,
  StepSeparator: _StepSeparator,
  StepStatus: _StepStatus,
  StepTitle: _StepTitle,
  Stepper: _Stepper,
  useStepContext: _useStepContext,
  useStepperStyles: _useStepperStyles,
  useSteps: _useSteps
});